import { Pipe, PipeTransform } from '@angular/core';
import { DocumentData } from '../../../app/modules/documents/interfaces/document-data.interface';
import { DocumentUploaderData } from '../../../app/modules/documents/interfaces/document-uploader-data.interface';
import { IsDeletableDocumentPipe } from './is-deletable-document';

@Pipe({
    name: 'areDeletableDocuments',
    pure: true,
    standalone: false,
})
export class AreDeletableDocumentsPipe implements PipeTransform {
    constructor(private isDeletableDocumentPipe: IsDeletableDocumentPipe) {}

    transform(documents: DocumentData[], documentUploaders: DocumentUploaderData[] | null): boolean {
        return documents.every((document) => {
            return this.isDeletableDocumentPipe.transform(document, documentUploaders);
        });
    }
}
